import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .content-container {
        padding: 2em 0;
        display: flex;
        flex-direction: column;

        .headline {
            font-size: 1.7em;
            font-weight: 700;
            color: #262626;
            text-align: center;
            position: relative;
            top: .3em;
            padding: 0 3em;
            margin-bottom: 3.6em;
        }

        .images-wrapper {
            .images-desktop {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                .image {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin: 1em;
                }

                .title {
                    color: #b29051;;
                    font-size: 2em;
                    font-weight: 700;
                    margin: 0.25em;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .content-container {

            .images-wrapper {
                .images-desktop {
                    display: none;
                }
            }
        }
    }

`;
